module.exports = __webpack_public_path__ + "static/img/business2.fdcb5a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/business2.png
// module id = 164
// module chunks = 1